import { z } from "zod";

export const GAMIFICATION_ACTION_VALUES = [
	"post_created",
	"comment_created",
	"post_reaction_given",
	"comment_reaction_given",
	"poll_voted",
	"dm_sent",
	"game_round_played",
	"game_round_won",
	"group_joined",
	"streak_day_extended",
	"quest_claimed",
] as const;
export const GamificationAction = {
	POST_CREATED: "post_created",
	COMMENT_CREATED: "comment_created",
	POST_REACTION_GIVEN: "post_reaction_given",
	COMMENT_REACTION_GIVEN: "comment_reaction_given",
	POLL_VOTED: "poll_voted",
	DM_SENT: "dm_sent",
	GAME_ROUND_PLAYED: "game_round_played",
	GAME_ROUND_WON: "game_round_won",
	GROUP_JOINED: "group_joined",
	STREAK_DAY_EXTENDED: "streak_day_extended",
	QUEST_CLAIMED: "quest_claimed",
} as const;
export type GamificationAction = (typeof GamificationAction)[keyof typeof GamificationAction];
export const gamificationActionSchema = z.enum(GAMIFICATION_ACTION_VALUES);

export const QUEST_TYPE_VALUES = ["daily", "weekly"] as const;
export const QuestType = {
	DAILY: "daily",
	WEEKLY: "weekly",
} as const;
export type QuestType = (typeof QuestType)[keyof typeof QuestType];
export const questTypeSchema = z.enum(QUEST_TYPE_VALUES);

export const QUEST_FILTER_VALUES = ["daily", "weekly", "all"] as const;
export const QuestFilter = {
	DAILY: "daily",
	WEEKLY: "weekly",
	ALL: "all",
} as const;
export type QuestFilter = (typeof QuestFilter)[keyof typeof QuestFilter];
export const questFilterSchema = z.enum(QUEST_FILTER_VALUES);

export const XP_SOURCE_TYPE_VALUES = [
	"post",
	"comment",
	"post_reaction",
	"comment_reaction",
	"dm_message",
	"poll_vote",
	"group_join",
	"streak",
	"quest_claim",
	"game_round",
] as const;
export const XpSourceType = {
	POST: "post",
	COMMENT: "comment",
	POST_REACTION: "post_reaction",
	COMMENT_REACTION: "comment_reaction",
	DM_MESSAGE: "dm_message",
	POLL_VOTE: "poll_vote",
	GROUP_JOIN: "group_join",
	STREAK: "streak",
	QUEST_CLAIM: "quest_claim",
	GAME_ROUND: "game_round",
} as const;
export type XpSourceType = (typeof XpSourceType)[keyof typeof XpSourceType];
export const xpSourceTypeSchema = z.enum(XP_SOURCE_TYPE_VALUES);

export const COSMETIC_TYPE_VALUES = ["frame", "sticker_pack", "theme_accent"] as const;
export const CosmeticType = {
	FRAME: "frame",
	STICKER_PACK: "sticker_pack",
	THEME_ACCENT: "theme_accent",
} as const;
export type CosmeticType = (typeof CosmeticType)[keyof typeof CosmeticType];
export const cosmeticTypeSchema = z.enum(COSMETIC_TYPE_VALUES);

export const BADGE_CRITERIA_TYPE_VALUES = [
	"post_count",
	"comment_count",
	"reactions_given",
	"streak",
	"level",
	"games_played",
	"games_won",
	"groups_joined",
	"polls_voted",
	"dms_sent",
] as const;
export const BadgeCriteriaType = {
	POST_COUNT: "post_count",
	COMMENT_COUNT: "comment_count",
	REACTIONS_GIVEN: "reactions_given",
	STREAK: "streak",
	LEVEL: "level",
	GAMES_PLAYED: "games_played",
	GAMES_WON: "games_won",
	GROUPS_JOINED: "groups_joined",
	POLLS_VOTED: "polls_voted",
	DMS_SENT: "dms_sent",
} as const;
export type BadgeCriteriaType = (typeof BadgeCriteriaType)[keyof typeof BadgeCriteriaType];
export const badgeCriteriaTypeSchema = z.enum(BADGE_CRITERIA_TYPE_VALUES);
